import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const NotFound = () => (
  <>
    <Navbar />
    <Box sx={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#1a0a2e',
      textAlign: 'center',
      py: 8
    }}>
      <Container maxWidth="sm">
        <Typography
          variant="h2"
          sx={{
            color: '#ffd700',
            fontWeight: 800,
            mb: 2,
            fontSize: { xs: '2.5rem', md: '3.5rem' }
          }}
        >
          404
        </Typography>
        <Typography
          variant="h5"
          sx={{
            color: 'white',
            fontWeight: 600,
            mb: 2,
            fontSize: { xs: '1.25rem', md: '1.5rem' }
          }}
        >
          You've gone off-beat!
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255,255,255,0.7)',
            mb: 5,
            lineHeight: 1.7,
            fontSize: { xs: '1rem', md: '1.1rem' }
          }}
        >
          Looks like this page missed its cue. Even our best dhol players
          can't find a rhythm here.
        </Typography>
        <Button
          variant="contained"
          size="large"
          component={Link}
          to="/"
          color="gold"
          sx={{
            px: 5,
            py: 2,
            textDecoration: 'none',
          }}
        >
          Back to Home
        </Button>
      </Container>
    </Box>
    <Footer />
  </>
);

export default NotFound;
